import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IntegrationQuickbooksService } from 'src/app/services/integration-quickbooks.service';
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MapInformationService } from 'src/app/services/map-information.service';
import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppConfigService } from 'src/app/app-config.service.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { AnonymousSubject, Subject } from 'rxjs/internal/Subject';
import CustomStore from 'devextreme/data/custom_store';
import { DatePipe, Location } from '@angular/common';
import { IMyOptions } from 'ng-uikit-pro-standard';
import DataGrid from "devextreme/ui/data_grid";
import { Router } from '@angular/router';
import Popup from 'devextreme/ui/popup';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';

import { TranslateService } from '@ngx-translate/core';
import { CreateUpdateActivityComponent } from '../../home/my-activity/create-update-activity/create-update-activity.component';
import { VoiceRecognitionService } from 'src/app/services/voice-recognition.service';
import { UserService } from 'src/app/services/user.service';
import { TextToVoiceService } from 'src/app/services/text-to-voice.service';
import DataSource from 'devextreme/data/data_source';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { count, groupBy, mergeMap, takeUntil, toArray } from 'rxjs/operators';
import { ContactService } from 'src/app/services/contact.service';

declare var $: any;

@Component({
  selector: 'edit-customer-reutilizable',
  templateUrl: './edit-customer-reutilizable.component.html',
  styleUrls: ['./edit-customer-reutilizable.component.scss']
})

export class EditCustomerReutilizableComponent implements OnInit, OnChanges {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild("newRequestBySelect", { static: false }) newRequestBySelect: DxSelectBoxComponent;
  @ViewChild("newRequestBySelectSelectDetail", { static: false }) newRequestBySelectSelectDetail: DxSelectBoxComponent;
  @ViewChild('updateActivity', { static: false }) updateActivity: CreateUpdateActivityComponent;
  @ViewChild("GridTemplate", { static: false }) GridTemplate: DxDataGridComponent;
  @ViewChild('row', { static: true }) row: ElementRef;
  @Input() VieneDe: any;
  @Input() customerID: any;
  optionsPerson: Array<any>;
  optionsCType: Array<any>;
  optionSregion: Array<any>;
  optionsCity: Array<any>;
  optionsState: Array<any>;
  optionsZip: Array<any>;
  elements: any = [];
  elements2: any = [];
  elements3: any = [];
  elements4: any = [];
  elements5: any = [];
  elements6: any = [];
  elements7: any = [];
  optionsCode = [];
  optionsSize = [];
  optionsRating = [];
  customerFilter = {
    PageIndex: 1,
    PageSize: 20,
    OrderID: 1,
    Id: 0,
    CustomerName: '',
    CustomerNumber: '',
    SalesPerson: '',
    CustomerType: '',
    SalesRegion: '',
    City: '',
    State: '',
    Zip: '',
    OfficePhone: '',
    HasCredit: '',
    Active: '',
    OffFax: ''
  };
  customerTypeSelect: any = [];
  modelCustomerType: any = [];
  salesPersonSelect: any = [];
  contrySelect: any = [];
  modelSalesPerson: any = [];
  customers: any = [];
  lastSearchZero: boolean = false;
  loading: boolean = false;

  deleteContacSelect: any;
  namedeleteContacSelect: any;

  viewDashboardType = 0;

  activo: boolean = true
  millisecondsInDay = 24 * 60 * 60 * 1000;
  filterValue: any
  customOperations: Array<any>;
  popupPosition: any;

  /**
   * Form new custumer vars
   */
  public _formEntity: FormGroup;
  public _formEntityEdit: FormGroup;
  public _formEntityAssociatePeople: FormGroup;
  public _formEntityActivity: FormGroup;
  public _showBillingAddress: boolean;
  options = [
    { value: '1', label: 'Option 1' },
    { value: '2', label: 'Option 2' },
    { value: '3', label: 'Option 3' },
  ];
  //End Form new custumer

  public myDatePickerOptions: IMyOptions = {
    // Your options
  };

  // Head tables
  headElements = [{ head: 'Contact Name', id: 'EstimateId', class: 'text-left' },
  { head: 'Company', id: 'ProjectName', class: 'text-left' }
  ];

  headElements2 = [{ head: 'Project Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-left' },
  { head: 'Quote Date', id: 'Category', class: 'text-right' },
  { head: 'Project Amount ', id: 'VerticalMarket', class: 'text-right' }
  ];


  headElements6 = [{ head: 'Project Number', id: 'EstimateId', class: 'text-right' },
  { head: 'Project Name', id: 'ProjectName', class: 'text-left' },
  { head: 'Quote Date', id: 'Category', class: 'text-right' },
  { head: 'Project Amount', id: 'VerticalMarket', class: 'text-right' }

  ];

  public chartType: string = 'line';

  public chartDatasets: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' },
    { data: [28, 48, 40, 19, 86, 27, 90], label: 'My Second dataset' }
  ];

  public chartLabels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(105, 0, 132, .2)',
      borderColor: 'rgba(200, 99, 132, .7)',
      borderWidth: 2,
    },
    {
      backgroundColor: 'rgba(0, 137, 132, .2)',
      borderColor: 'rgba(0, 10, 130, .7)',
      borderWidth: 2,
    }
  ];

  public chartOptions: any = {
    responsive: true
  };
  headers: any;
  openAIGenerate: boolean = false;
  // sendMessage: { icon: string; type: string; onClick: () => void; };
  optionsButton: {
    icon: string; type: string; hint: string; elementAttr: {
      style: string; // Agrega un margen izquierdo de 10px
    }; onClick: () => void;
  };
  dateFormat: any;
  todayButtondateex: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  prevDateButtondateex: { icon: string; stylingMode: string; onClick: () => void; };
  nextDateButtondateex: { icon: string; stylingMode: string; onClick: () => void; };
  cancelButton: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveButton: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  saveNewButton: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  saveEditButton: { text: any; elementAttr: { id: string; }; onClick: () => void; };
  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }


  // bar
  public chartType2: string = 'bar';

  public chartDatasets2: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' }
  ];

  public chartLabels2: Array<any> = ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'];

  public chartColors2: Array<any> = [
    {
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
        'rgba(255, 159, 64, 1)'
      ],
      borderWidth: 2,
    }
  ];

  public chartOptions2: any = {
    responsive: true
  };
  public chartClicked2(e: any): void { }
  public chartHovered2(e: any): void { }


  // horizontal
  public chartType3: string = 'horizontalBar';

  public chartDatasets3: Array<any> = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'My First dataset' }
  ];

  public chartLabels3: Array<any> = ['Red', 'Blue', 'Yellow'];

  public chartColors3: Array<any> = [
    {
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)'

      ],
      borderColor: [
        'rgba(255,99,132,1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)'

      ],
      borderWidth: 2,
    }
  ];

  public chartOptions3: any = {
    responsive: true
  };

  public chartClicked3(e: any): void { }
  public chartHovered3(e: any): void { }
  dateFormat1: any


  customerDataSource: any;
  customerSelecte: any;
  dataCardList: any[] = []
  todayButtonreqDate: any;
  prevDateButtonreqDate: any;
  nextDateButtonreqDate: any;
  reqDate: number
  optionsRegion: any[] = []
  optionsTax: any[] = []
  optionFreelancer: any[] = []
  optionsSalesPerson: any[] = []
  houseNumber: any = ""
  street: any = ""
  mapCity: any = ""
  mapState: any = ""
  mapcountry: any = ""
  mapPaostalCode: any = ""

  houseNumberBilling: any = ""
  streetBilling: any = ""
  mapCityBilling: any = ""
  mapStateBilling: any = ""
  mapcountryBilling: any = ""
  mapPaostalCodeBilling: any = ""

  contadorPaginacion: number = 1
  page: number = 1;

  cancelButtonFilter: any
  saveButtonFilter: any
  cancelButtonFilterActivity: any
  saveButtonFilterActivity: any
  workcompleteddate: number;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;

  followUpDate: number;
  todayButtonfollowUpDate: any;
  prevDateButtonfollowUpDate: any;
  nextDateButtonfollowUpDate: any;
  addProdSpeButton: any
  popupActivityType: boolean = false
  nombreActivity: any = "New Activity"
  EnableIntegration: boolean = true
  CreatedOn: any
  PopupNewAssociatePeopple: boolean = false
  PopupNewActivity: boolean = false
  durationDetail: any
  Activity: any[] = []
  AssociatePeopple: any[] = []
  optionsType: any[] = []
  optionsInfluence: any[] = []
  optionsPeopleAsc: any[] = []
  optionsPeople: any[] = []
  gotoEdit: boolean = false
  durationEdit: any
  popupNewContact: boolean = false
  NameContact: any = ""
  cargandoScroll: number = 0
  contactDataSource: any


  gridDataSource: any[] = []
  DataSourceSites: any[] = []

  checkBoxShowActive: boolean = true;
  checkBoxShowInactive: boolean = false;
  // Projects
  gridDataSourceSale: any[] = []
  gridDataSourceBid: any[] = [];

  plusResponsibleButton: any;
  customerProfile: any = null;

  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];

  dateex: number = new Date().getTime();

  @ViewChild('componentSales', { static: false }) componentSales: any;
  type = 1

  addRequestByButton: any
  popupNewContactNew: boolean = false

  addSalesPersonButton: any
  popupNewEmployee: boolean = false

  popupSalesPerson: boolean = false

  isWebsiteInvalid: boolean = false;

  constructor(
    private integrationService: IntegrationQuickbooksService,
    public MapInformationService: MapInformationService,
    public appConfigService: AppConfigService,
    private customerService: CustomerService,
    public service: VoiceRecognitionService,
    private generalService: GeneralService,
    private translate: TranslateService,
    public userService: UserService,
    private toast: ToastService,
    private location: Location,
    private pipeDate: DatePipe,
    public fb: FormBuilder,
    private router: Router,
    private salesLeadsService: SalesProjectService,
    private textToVoiceService: TextToVoiceService,
    private contactService: ContactService,
  ) {

    this.dateFormat1 = this.appConfigService.dateFormat
    this.customerSelecte = null;
    this.workcompleteddate = new Date().getTime();
    this.Get_VendorsAll();

    this.todayButtonfollowUpDate = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.followUpDate = new Date().getTime();
      }
    };

    this.prevDateButtonfollowUpDate = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.followUpDate -= this.millisecondsInDay;
      }
    };

    this.nextDateButtonfollowUpDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.followUpDate += this.millisecondsInDay;
      }
    };

    this.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.workcompleteddate = new Date().getTime();
      }
    };

    this.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.workcompleteddate -= this.millisecondsInDay;
      }
    };

    this.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.workcompleteddate += this.millisecondsInDay;
      }
    };

    this.cancelButtonFilter = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewAssociatePeopple()
      },
    };

    this.saveButtonFilter = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.SaveNewAssociatePeople()
      },
    }

    this.cancelButtonFilterActivity = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.CloseNewActivity()
      },
    };

    this.saveButtonFilterActivity = {
      text: this.translate.instant('ModuleEditCustomerNAct.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.SaveNewActivity()
      },
    }

    this.todayButtonreqDate = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.reqDate = new Date().getTime();
      }
    };

    this.prevDateButtonreqDate = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.reqDate -= this.millisecondsInDay;
      }
    };

    this.nextDateButtonreqDate = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.reqDate += this.millisecondsInDay;
      }
    };

    this.addProdSpeButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.popupActivityType = true;
      },
    };

    this.todayButtondateex = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        this.dateex = new Date().getTime();
      }
    };

    this.prevDateButtondateex = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        this.dateex -= this.millisecondsInDay;
      }
    };

    this.nextDateButtondateex = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        this.dateex += this.millisecondsInDay;
      }
    };

    this.cancelButton = {
      text: this.translate.instant('ModaleSalesProjectNSProj.btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.componentSales.ngOnInit();
        this.popupCreateSalesProject = false;
      },
    };

    this.saveButton = {
      text: this.translate.instant('ModaleSalesProjectNSProj.btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.type = 1;
        this.componentSales.updateSalesProject(1);
      },
    };

    this.saveNewButton = {
      text: this.translate.instant('ModaleSalesProjectNSProj.btnSaveNew'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.type = 2;
        this.componentSales.updateSalesProject(2);
      }
    };

    this.saveEditButton = {
      text: this.translate.instant('ModaleSalesProjectNSProj.btnSaveEdit'),
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.type = 3;
        this.componentSales.updateSalesProject(3);
      }
    };

    this.addRequestByButton = {
      icon: "plus",
      type: "button",
      onClick: () => {
        this.popupNewContactNew = true;
      },
      disabled: false
    };

    this.addSalesPersonButton = {
      icon: "edit",
      type: "button",
      onClick: () => {
        // this.popupNewEmployee=true
        // console.log(this.optionsLead)
        this.getEmployeesNoSales()
        this.popupSalesPerson = true;
      },
      disabled: false
    };




    this.initForm()
    this.getContactsCustomer()


    // this._formEntity = fb.group({
    //   CustomerName: [null, [Validators.required, Validators.maxLength(45)]],
    //   CustomerNumber: [null, []],
    //   CustomerTpeId: [{ value: 12, disabled: false }, []],
    //   OffPhone: [null, [Validators.maxLength(20)]],
    //   OffFax: [null, [Validators.maxLength(20)]],
    //   WebSite: [null, []],
    //   Address: [null, []],
    //   City: [null, []],
    //   Zip: [null, []],
    //   EmployeeId: [{ value: 1, disabled: false }, []],
    //   State: [null, []],
    //   Country: [{ value: 'USA', disabled: false }, []],
    //   Billing: [null, []],
    //   Notes: [null, []],
    //   BillingName: [null, [Validators.maxLength(50)]],
    //   BillingAddress: [null, []],
    //   BillingCity: [null, []],
    //   BillingZip: [null, []],
    //   BillingState: [null, []],
    //   BillingCountry: [{ value: 'USA', disabled: false }, []],
    // });
    this._showBillingAddress = true;
    this.deleteContacSelect = null;
    this.namedeleteContacSelect = null;



    // this.sendMessage = {
    //   icon: "fas fa-paper-plane c-blue",
    //   type: "button",
    //   onClick: () => {
    //     this.SendMessageAI()
    //   },
    // };

    this.optionsButton = {
      icon: "fas fa-filter c-blue",
      type: "button",
      hint: "Options",
      elementAttr: {
        style: "margin-left: 10px;" // Agrega un margen izquierdo de 10px
      },
      onClick: () => {
        this.toggleOptionsMenu();
      },
    };
  }

  validateWebsite() {
    const website = this._formEntityEdit.get('website').value;
    const urlPattern = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    this.isWebsiteInvalid = website && !urlPattern.test(website);
  }

  changeEmployeeNoSales(obj, item) {
    item.add = obj.value;
  }

  employeesNoSalesSelect: any = []

  getEmployeesNoSales() {
    this.salesLeadsService.GetEmployeesNoSales().subscribe(result => {
      this.employeesNoSalesSelect = result;
    })
  }

  addTypeRegion: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.VieneDe == "Customer") {
      if (changes.customerID != undefined) {
        this.customerID = changes.customerID.currentValue
        this.initForm()
        this.workcompleteddate = new Date().getTime();

        this.todayButton = {
          text: this.translate.instant('btnToday'),
          elementAttr: {
            id: 'today-Btn'
          },
          onClick: () => {
            this.workcompleteddate = new Date().getTime();
          }
        };

        this.prevDateButton = {
          icon: "spinprev",
          stylingMode: "text",
          onClick: () => {
            this.workcompleteddate -= this.millisecondsInDay;
          }
        };

        this.nextDateButton = {
          icon: "spinnext",
          stylingMode: "text",
          onClick: () => {
            this.workcompleteddate += this.millisecondsInDay;
          }
        };
        this.searchInfoToSelect()
      }
    }
  }

  GoToContactNew() {
    this.router.navigateByUrl(`/contacts/editContact/${this._formEntityEdit.get("maincontactid").value}`);
  }

  ngOnInit() {





    const customerdata = JSON.parse(localStorage.getItem('customerData'));
    const customerfilter = JSON.parse(localStorage.getItem('customerFilter'));
    if (customerfilter) {
      this.customerFilter = customerfilter;
      this.modelCustomerType = this.customerFilter.CustomerType.split(',').map(item => {
        const el = parseInt(item, 10);
        if (!isNaN(el)) {
          return el;
        }
      });
      this.modelSalesPerson = this.customerFilter.SalesPerson.split(',').map(item => {
        const el = parseInt(item, 10);
        if (!isNaN(el)) {
          return el;
        }
      });
    }

    this.customerFilter.PageIndex = 1;
    this.GetCustomersWithFilters();

    this.GetSalesPerson();
    this.GetCustomerType();
    this.GetCountries();
    this.elements.push({ EstimateId: '5539', ProjectName: '2992', Category: 'Royal Concrete Concepts', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5540', ProjectName: '2993', Category: '44 North', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5541', ProjectName: '2994', Category: 'Adams', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });
    this.elements.push({ EstimateId: '5542', ProjectName: '2995', Category: 'ABC Controls', VerticalMarket: 'Jose Smith', Status: 'Mechanical Contractor', Date: 'West Palm', city: 'Miami', state: 'Florida', zip: '32127', oficPhone: '386-252-12-22', oficFax: '305-555-888' });

    this.elements2.push({ EstimateId: '5567', ProjectName: 'Using cube resources', Category: '04/04/2019', VerticalMarket: '113,000.00' });
    this.elements2.push({ EstimateId: '5540', ProjectName: 'Crowne Pointe 4030 Building', Category: '04/06/2019', VerticalMarket: '113,000.00' });
    this.elements2.push({ EstimateId: '5541', ProjectName: 'Dever International Airport', Category: '04/10/2019', VerticalMarket: '251,000.00' });
    this.elements2.push({ EstimateId: '5542', ProjectName: 'Westwood Christian', Category: '04/12/2019', VerticalMarket: '25.00' });

    this.elements6.push({ EstimateId: '5567', ProjectName: 'Using cube resources', Category: '04/04/2019', VerticalMarket: '113,000.00' });
    this.elements6.push({ EstimateId: '5540', ProjectName: 'Crowne Pointe 4030 Building', Category: '04/06/2019', VerticalMarket: '113,000.00' });
    this.elements6.push({ EstimateId: '5541', ProjectName: 'Dever International Airport', Category: '04/10/2019', VerticalMarket: '251,000.00' });
    this.elements6.push({ EstimateId: '5542', ProjectName: 'Westwood Christian', Category: '04/12/2019', VerticalMarket: '25.00' });

    this.customScroll();

    this.searchInfoToSelect()
    this.EnableButton()


    this.MapInformationService.SaveInfoSites({ method: "Get_ClientSettingsByName", name: "CustomerCreditApprovers" })
      .subscribe(resp => {
        let idUserLogged = localStorage.getItem("customerid")
        this.findId = (resp[0].VALUE.split(',').includes(idUserLogged.toString()));
      })


    this.addTypePurchase = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.goUtilityRegion()
      },
      disabled: false
    };


  }

  addTypePurchase: any

  expandAll: boolean = false
  findId: any

  setGrid2() {
    let mythis = this;
    // this.customerDataSource = AspNetData.createStore({
    //   key: "ID",
    //   loadUrl: this.customerService.GetCustomerFilterUrl(),
    //   onLoaded: function (data) {
    //     let infoFinal = []
    //     data.forEach(element => {
    //       if (element.AVAILABLE) {
    //         element.AVAILABLEYesOrNo = "Yes"
    //       } else {
    //         element.AVAILABLEYesOrNo = "No"
    //       }
    //       if (element.HASCREDIT) {
    //         element.HASCREDITYesOrNo = "Yes"
    //       } else {
    //         element.HASCREDITYesOrNo = "No"
    //       }
    //       infoFinal.push(element)
    //     })
    //     data = infoFinal

    //     // mythis.dataCardList = data

    //     if (!mythis.headers && data.length > 0)
    //       mythis.headers = Object.keys(data[0]);

    //     // if (data.length == 0)
    //     //   mythis.customerDataSource = [];
    //   },
    //   onBeforeSend: function (e, ajaxOptions) {
    //     mythis.loading = false;


    //     if (ajaxOptions.data.sort) {
    //       let sort = JSON.parse(ajaxOptions.data.sort);
    //       mythis.customerFilter.OrderID = mythis.headers.indexOf(sort[0].selector);
    //       if (sort[0].desc) {
    //         mythis.customerFilter.OrderID = mythis.customerFilter.OrderID * -1;
    //       }
    //     }

    //     // mythis.filterPipeline.OrderId = mythis.filterPipeline.OrderId * -1;
    //     ajaxOptions.method = 'POST';
    //     // mythis.customerFilter.PageIndex = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
    //     let page = (ajaxOptions.data.skip / 20) == 0 ? 1 : ajaxOptions.data.skip / 20;
    //     mythis.customerFilter.PageIndex = ajaxOptions.data.skip ? page : mythis.customerFilter.PageIndex;

    //     let filters = Object.assign({}, mythis.customerFilter);

    //     ajaxOptions.data = JSON.stringify(filters);
    //     ajaxOptions.contentType = 'application/json';
    //     ajaxOptions.headers = {
    //       'Authorization': `Bearer ${localStorage.getItem('token')}`
    //     }
    //   }
    // });
  }

  showFilter() {
  }

  clearFilterCompany() {
  }

  searchCompany(id) {
    const data = {
      method: "Get_Customers",
      id: id
    }
    this.MapInformationService.SaveInfoSites(data).subscribe(
      // this.customerService.GetCustumerById(id).subscribe(
      data => {
        // CUSTOMERNAME
        this.formDataLoad(data[0]);
      },
      err => {
      }
    )
  }

  formDataLoad(infoCompany) {
    // Convertir en array el string
    let otherPeople;
    otherPeople = [];
    if (infoCompany.OTHESALESPERSONIDS !== '' && infoCompany.OTHESALESPERSONIDS !== null) {
      otherPeople = (infoCompany.OTHESALESPERSONIDS.split(','));
      let arryTemp;
      arryTemp = [];
      otherPeople.forEach(element => {
        arryTemp.push(parseInt(element));
      });
      otherPeople = arryTemp;
    } else {

    }

    let dateFormat = 0;
    if (infoCompany.CREATEDDATE != undefined) {
      dateFormat = new Date(infoCompany.CREATEDDATE).getTime();
    }

    const website = infoCompany['WEBSITE'];
    let domain = '';

    if (website) {
      try {
        let formattedWebsite = website;

        // Agregar "http://" si la URL comienza con "www" pero no tiene un esquema
        if (website.startsWith('www.')) {
          formattedWebsite = `http://${website}`;
        }

        // Crear un objeto URL para extraer el dominio
        const url = new URL(formattedWebsite);
        const hostname = url.hostname;

        // Extraer solo el dominio principal (sin subdominios)
        const parts = hostname.split('.');
        if (parts.length > 2) {
          domain = parts.slice(-2).join('.'); // Tomar los últimos dos segmentos (por ejemplo, "example.com")
        } else {
          domain = hostname; // Si no hay subdominios, usar el hostname completo
        }

        infoCompany.domain = domain;
      } catch (error) {
        infoCompany.domain = ''; // Si la URL no es válida, asignar un string vacío
      }
    } else {
      infoCompany.domain = ''; // Si no hay URL, asignar un string vacío
    }

    this.dateFormat = this.appConfigService.dateFormat



    this.CreatedOn = this.pipeDate.transform(infoCompany.CREATEDDATE, 'MM/dd/yyyy');

    this._formEntityEdit = new FormGroup({
      id: new FormControl({ value: infoCompany.ID, disabled: false }, []),
      customername: new FormControl({ value: infoCompany.CUSTOMERNAME, disabled: false }, [Validators.required, Validators.maxLength(45)]),
      customernumber: new FormControl({ value: infoCompany.NUMBER, disabled: false }, []),
      customertypeid: new FormControl({ value: infoCompany.CUSTOMERTYPEID, disabled: false }, []),
      offphone: new FormControl({ value: infoCompany.OFFPHONE, disabled: false }, [Validators.maxLength(20)]),
      phone2: new FormControl({ value: infoCompany.OFFPHONE2, disabled: false }, [Validators.maxLength(20)]),
      website: new FormControl({ value: infoCompany.WEBSITE, disabled: false }, []),
      offfax: new FormControl({ value: infoCompany.OFFFAX, disabled: false }, [Validators.maxLength(20)]),
      emailaddress: new FormControl({ value: infoCompany.EMAILADDRESS, disabled: false }, []),
      domain: new FormControl({ value: infoCompany.domain, disabled: false }, []),
      address: new FormControl({ value: infoCompany.ADDRESS, disabled: false }, []),
      addressline2: new FormControl({ value: infoCompany.ADDRESSLINE2, disabled: false }, []),
      city: new FormControl({ value: infoCompany.CITY, disabled: false }, []),
      employeeid: new FormControl({ value: parseInt(infoCompany.EMPLOYEEID), disabled: false }, []),
      zip: new FormControl({ value: infoCompany.ZIP, disabled: false }, []),
      state: new FormControl({ value: infoCompany.STATE, disabled: false }, []),
      country: new FormControl({ value: infoCompany.COUNTRY, disabled: false }, []),
      Billing: new FormControl({ value: 0, disabled: false }, []),
      customernotes: new FormControl({ value: infoCompany.NOTES, disabled: false }, []),
      billingname: new FormControl({ value: infoCompany.BILLINGADDRESSNAME, disabled: false }, []),
      billingaddress: new FormControl({ value: infoCompany.BILLINGADDRESS, disabled: false }, []),
      billingaddressline2: new FormControl({ value: infoCompany.BILLINGADDRESSLINE2, disabled: false }, []),
      billingcity: new FormControl({ value: infoCompany.BILLINGCITY, disabled: false }, []),
      billingzip: new FormControl({ value: infoCompany.BILLINGZIP, disabled: false }, []),
      billingstate: new FormControl({ value: infoCompany.BILLINGSTATE, disabled: false }, []),
      billingcountry: new FormControl({ value: infoCompany.BILLINGCOUNTRY, disabled: false }, []),
      othersalespersonids: new FormControl({ value: otherPeople, disabled: false }, []),
      salesregionid: new FormControl({ value: parseInt(infoCompany.SALESREGIONID), disabled: false }, []),
      hascredit: new FormControl({ value: infoCompany.HASCREDIT, disabled: false }, []),
      available: new FormControl({ value: infoCompany.AVAILABLE, disabled: false }, []),
      salestaxid: new FormControl({ value: infoCompany.SALESTAXID, disabled: false }, [Validators.required]),
      freelancerid: new FormControl({ value: infoCompany.FreelancerId == null ? '' : infoCompany.FreelancerId, disabled: false }, []),
      maincontactid: new FormControl({ value: infoCompany.maincontactid == null ? '' : infoCompany.maincontactid, disabled: false }, []),
      date: new FormControl({ value: dateFormat, disabled: true }, []),
      CreateBy: new FormControl({ value: infoCompany.USERNAME, disabled: true }, []),
      mastermanufacturerid: new FormControl({ value: infoCompany.MasterManufacturerID, disabled: false }, []),
      target: new FormControl({ value: infoCompany.TARGET, disabled: false }, []),
    });

    this.customerProfile = infoCompany.Customerprofile

    this.newRequestBySelectSelectDetail.placeholder = infoCompany.maincontactname

  }

  initForm() {
    this._formEntityEdit = new FormGroup({
      id: new FormControl({ value: '', disabled: false }, []),
      customername: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      customernumber: new FormControl({ value: '', disabled: false }, []),
      customertypeid: new FormControl({ value: '', disabled: false }, []),
      offphone: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      phone2: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      website: new FormControl({ value: '', disabled: false }, []),
      offfax: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
      emailaddress: new FormControl({ value: '', disabled: false }, []),
      domain: new FormControl({ value: '', disabled: false }, []),
      address: new FormControl({ value: '', disabled: false }, []),
      addressline2: new FormControl({ value: '', disabled: false }, []),
      city: new FormControl({ value: '', disabled: false }, []),
      employeeid: new FormControl({ value: '', disabled: false }, []),
      zip: new FormControl({ value: '', disabled: false }, []),
      state: new FormControl({ value: '', disabled: false }, []),
      country: new FormControl({ value: '', disabled: false }, []),
      Billing: new FormControl({ value: 0, disabled: false }, []),
      customernotes: new FormControl({ value: '', disabled: false }, []),
      billingaddress: new FormControl({ value: '', disabled: false }, []),
      billingaddressline2: new FormControl({ value: '', disabled: false }, []),
      billingname: new FormControl({ value: '', disabled: false }, []),
      billingcity: new FormControl({ value: '', disabled: false }, []),
      billingzip: new FormControl({ value: '', disabled: false }, []),
      billingstate: new FormControl({ value: '', disabled: false }, []),
      billingcountry: new FormControl({ value: '', disabled: false }, []),
      othersalespersonids: new FormControl({ value: '', disabled: false }, []),
      salesregionid: new FormControl({ value: '', disabled: false }, []),
      hascredit: new FormControl({ value: false, disabled: false }, []),
      available: new FormControl({ value: false, disabled: false }, []), 
      target: new FormControl({ value: false, disabled: false }, []), 
      date: new FormControl({ value: '', disabled: true }, []),
      salestaxid: new FormControl({ value: 3, disabled: false }, []),
      freelancerid: new FormControl({ value: 0, disabled: false }, []),
      maincontactid: new FormControl({ value: 0, disabled: false }, []),
      // CustomerTpeId
      CreateBy: new FormControl({ value: '', disabled: true }, []),
      mastermanufacturerid: new FormControl({ value: '', disabled: false }, []),
    });

    this._formEntityAssociatePeople = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      customerid: new FormControl({ value: this.customerID, disabled: false }, []),
      description: new FormControl({ value: '', disabled: false }, []),
      buyetypeid: new FormControl({ value: 2, disabled: false }, []),
      influenceid: new FormControl({ value: 2, disabled: false }, []),
      contactid: new FormControl({ value: 0, disabled: false }, [Validators.required]),
    })

    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      Customer: new FormControl({ value: this.customerID, disabled: true }, []),
      CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
      FOLLOWUPDATE: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  searchInfoToSelect() {
    this.customerService.GetCustomerType().subscribe(result => {
      this.customerTypeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CUSTOMERTYPE,
          value: val.ID
        };
      });
      // this.MapInformationService.SaveInfoSites({method:""}).subscribe(
      this.customerService.GetCustomerSalesRegion().subscribe(
        // this.MapInformationService.SaveInfoSites({method:''}).subscribe(
        data => {
          this.optionsRegion = data.map((val) => {
            return { // Return the new object structure
              label: val.SALESREGION,
              value: val.ID
            };
          });
          this.viewDashboardType = 2
        }
      );
      this.generalService.GetSalesPerson().subscribe(
        data => {
          this.optionsSalesPerson = data.map((val) => {
            return { // Return the new object structure
              label: val.CONTACTNAME,
              value: val.ID
            };
          });
          this.MapInformationService.SaveInfoSites({ method: 'Get_Taxs' }).subscribe(
            // this.customerService.GetCustomerTaxes().subscribe(
            data => {
              this.optionsTax = data.map((val) => {
                if (val.TAX != undefined)
                  return { // Return the new object structure
                    label: val.TAX,
                    value: val.ID
                  };
              });
              // this.customerID = this.dataCardList[0].ID
              this.searchCompany(this.customerID)
              this.customScroll()
            }
          );

          this.MapInformationService.SaveInfoSites({ method: "Get_CW_ApplicantList" }).subscribe(resp => {
            console.log(resp)
            this.optionFreelancer = resp
          })

        }
      );
    });
    // })
  }

  OpenNewAssociatePeopple() {
    let mythis = this
    this.contactDataSource = []
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
    this.PopupNewAssociatePeopple = true
  }

  OpenNewActivity() {
    this.PopupNewActivity = true;
    // this._formEntityActivity = new FormGroup({
    //   Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
    //   Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
    //   Customer: new FormControl({ value: this.customerID, disabled: true }, []),
    //   CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
    //   EmployeeId: new FormControl({ value: 1, disabled: false }, []),
    //   Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
    //   Notes: new FormControl({ value: '', disabled: false }, []),
    //   StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
    //   FOLLOWUPDATE: new FormControl({ value: '', disabled: false }, []),
    //   Follow: new FormControl({ value: '', disabled: false }, []),
    //   Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    //   Closed: new FormControl({ value: '', disabled: false }, []),
    //   FollowComments: new FormControl({ value: '', disabled: false }, []),
    //   durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
    // });
  }

  CloseNewActivity() {
    this.PopupNewActivity = false
    this._formEntityActivity = new FormGroup({
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      Customer: new FormControl({ value: this.customerID, disabled: true }, []),
      CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartTime: new FormControl({ value: new Date().getTime(), disabled: false }, [Validators.required]),
      FOLLOWUPDATE: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Closed: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
      durationDetail: new FormControl({ value: '', disabled: false }, [Validators.required]),
    });
    this.gotoEdit = false
    this.nombreActivity = "'ModalEditCustomerNAct.title' | translate";
  }

  CloseNewAssociatePeopple() {
    this.contactDataSource = []
    this.newRequestBySelect.placeholder = "Select.."
    this.PopupNewAssociatePeopple = false
    this.NameContact = ""
    this._formEntityAssociatePeople = new FormGroup({
      id: new FormControl({ value: 0, disabled: false }, []),
      customerid: new FormControl({ value: this.customerID, disabled: false }, []),
      description: new FormControl({ value: '', disabled: false }, []),
      buyetypeid: new FormControl({ value: 2, disabled: false }, []),
      influenceid: new FormControl({ value: 2, disabled: false }, []),
      contactid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    })
  }

  Volver() {
    if (localStorage.getItem("VolverSalesProject") != undefined) {
      this.router.navigateByUrl(`/salesProject/editSales/${localStorage.getItem("VolverSalesProjectID")}`);
    } else if (localStorage.getItem("VolverEditProjectContract") != undefined) {
      this.router.navigateByUrl(`/editProject?numID=${localStorage.getItem("VolverEditProjectContract")}`);
    } else {
      localStorage.setItem('DeEditRequisition', "EditRequisition")
      this.location.back();
      // this.router.navigateByUrl(`/customers`)
    }

    localStorage.removeItem("VolverSalesProject")
    localStorage.removeItem("VolverSalesProjectID")
    localStorage.removeItem("VolverEditProjectContract")

  }

  getAllCompanies() {
    const data = {
      method: ""
    }
  }

  DeleteCompany(item) {
  }

  ShowInfoCompany(item) {
    this.customerID = item.CUSTOMERID
    this.searchCompany(item.CUSTOMERID)
  }

  handleValueChange(event) {
    if (event.value) {
      this._formEntityEdit.get("billingaddress").setValue(this._formEntityEdit.value.address)
      this._formEntityEdit.get("billingcity").setValue(this._formEntityEdit.value.city)
      this._formEntityEdit.get("billingzip").setValue(this._formEntityEdit.value.zip)
      this._formEntityEdit.get("billingstate").setValue(this._formEntityEdit.value.state)
      this._formEntityEdit.get("billingcountry").setValue(this._formEntityEdit.value.country)
      this._formEntityEdit.get("billingaddressline2").setValue(this._formEntityEdit.value.addressline2)
    } else {
      this._formEntityEdit.get("billingaddress").setValue("")
      this._formEntityEdit.get("billingcity").setValue("")
      this._formEntityEdit.get("billingzip").setValue("")
      this._formEntityEdit.get("billingstate").setValue("")
      this._formEntityEdit.get("billingcountry").setValue("")
      this._formEntityEdit.get("billingaddressline2").setValue("")
    }
  }

  submitForm() {
    if (this.isWebsiteInvalid) {
      this.toast.warning('Please provide a valid website URL.');
      return;
    }

    let formValue;
    formValue = this._formEntityEdit.value;
    formValue = { CustomerId: this._formEntityEdit.value.id, ...formValue };
    //Coverit a string Other sales person seprados por coma
    let ArraystrinOtherSlaesPerosn: string;
    // Same Address

    if (formValue.Billing === 0) {
      // delete formValue.BillingAddress
      formValue = { customeraddresssame: 'false', ...formValue };
    } else {
      //  Error: El servicio no esta guardandolos campos a continuacion
      formValue.billingaddress = formValue.address;
      formValue.billingcity = formValue.city;
      formValue.billingzip = formValue.zip;
      formValue.billingstate = formValue.state;
      formValue.billingcountry = formValue.country;
      formValue.billingaddressline2 = formValue.addressline2;
      // Se implementa el siguiente campo customeraddresssame
      formValue = { customeraddresssame: 'true', ...formValue };
    }

    ArraystrinOtherSlaesPerosn = '';
    if (formValue.hascredit === true) {
      formValue.hascredit = 1
    } else {
      formValue.hascredit = 0
    }
    if (formValue.available === true) {
      formValue.available = 1
    } else {
      formValue.available = 0
    }
    if (formValue.target === true) {
      formValue.target = 1
    } else {
      formValue.target = 0
    }

    if (formValue.othersalespersonids.length > 0) {
      let i = 0;
      formValue.othersalespersonids.forEach(element => {
        if (i === 0) {
          ArraystrinOtherSlaesPerosn = element;
        } else {
          ArraystrinOtherSlaesPerosn = ArraystrinOtherSlaesPerosn + ',' + element;
        }
        i++;
      });
      formValue.othersalespersonids = ArraystrinOtherSlaesPerosn
    } else {
      // Vacio
      formValue.othersalespersonids = "";
    }
    formValue.customergoogleadd = formValue.address



    // if(formValue.billingaddress != undefined){
    //   if (formValue.billingaddress.length > 14 || formValue.address.length > 14) {
    //     let primeraparteAddressBilling = formValue.billingaddress.slice(0, formValue.billingaddress.length / 2)
    //     let segundaparteAddressBilling = formValue.billingaddress.slice(formValue.billingaddress.length / 2)

    //     let primeraparteAddress = formValue.address.slice(0, formValue.address.length / 2)
    //     let segundaparteAddress = formValue.address.slice(formValue.address.length / 2)

    //     formValue.address = primeraparteAddress
    //     formValue.addressline2 = segundaparteAddress
    //     formValue.billingaddress = primeraparteAddressBilling
    //     formValue.billingaddressline2 = segundaparteAddressBilling
    //   } else {
    //     formValue.addressline2 = ""
    //     formValue.billingaddressline2 = ""
    //   }
    // }
    // formValue.Billing = formValue.Billing ? 1 : 0;
    delete formValue.Billing;
    formValue.method = "Insert_Customer"
    formValue.profile = this.customerProfile


    if (formValue.maincontactid == undefined || formValue.maincontactid == null || formValue.maincontactid == '') {
      delete formValue.maincontactid
    }

    if (this.dataHtml == 'Notes') {
      formValue.customernotes = this.dataFromAI
    } else if (this.dataHtml == 'Profile') {
      formValue.profile = this.dataFromAI
    }

    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      // this.customerService.EditCustumerById(formValue).subscribe(
      data => {
        this.toast.success(this.translate.instant('msgCustEditSucc'));
        this.ngOnInit();
        this.searchCompany(this.customerID)

      },
      err => {
      }
    )
  }


  titleClick(e) {
    switch (e.itemData.title) {
      case 'Activity':
        this.getActivity()
        break
      case 'Customer Contacts Relationship':
        this.getAssociatePeople(0)
        break
      case 'Projects':
        this.getProjects()
        break
      case 'Project Sale History':
        this.getProjectsSale()
        break
      case 'Project Bid History':
        this.getProjectsBid()
        break
      case 'Service Site':
        this.getServiceSite()
        break
    }
  }

  getProjects() {
    let method = 'Get_All_Projects'

    this.MapInformationService.SaveInfoSites({ method: "Get_All_Projectsbycustomer", custooomerid: this.customerID }).subscribe(data => {
      let infoFinal = []
      data.forEach(element => {
        if (element.IsPipeline) {
          element.IsPipelineYesOrNot = "Yes"
        } else {
          element.IsPipelineYesOrNot = "No"
        }
        if (element.ico_Sold == "fas  fa-exclamation-circle whiteiconcolor/ ") {
          element.ico_SoldYesOrNot = "No"
        } else {
          element.ico_SoldYesOrNot = "Yes"
        }
        infoFinal.push(element)
      });
      this.gridDataSource = infoFinal;

      this.onloadData(this.gridDataSource)
    })
  }

  getProjectsSale() {

    this.MapInformationService.SaveInfoSites({ method: "Get_CustomersSaleHistory", customerid: this.customerID }).subscribe(data => {
      let infoFinal = []
      data.forEach(element => {
        if (element.IsPipeline) {
          element.IsPipelineYesOrNot = "Yes"
        } else {
          element.IsPipelineYesOrNot = "No"
        }
        if (element.ico_Sold == "fas  fa-exclamation-circle whiteiconcolor/ ") {
          element.ico_SoldYesOrNot = "No"
        } else {
          element.ico_SoldYesOrNot = "Yes"
        }
        infoFinal.push(element)
      });
      this.gridDataSourceSale = infoFinal;

      this.onloadData(this.gridDataSourceSale)
    })
  }

  getProjectsBid() {

    this.MapInformationService.SaveInfoSites({ method: "Get_CustomersBidHistoryCE", customerid: this.customerID }).subscribe(data => {
      let infoFinal = []
      data.forEach(element => {
        if (element.IsPipeline) {
          element.IsPipelineYesOrNot = "Yes"
        } else {
          element.IsPipelineYesOrNot = "No"
        }
        if (element.ico_Sold == "fas  fa-exclamation-circle whiteiconcolor/ ") {
          element.ico_SoldYesOrNot = "No"
        } else {
          element.ico_SoldYesOrNot = "Yes"
        }
        infoFinal.push(element)
      });
      this.gridDataSourceBid = infoFinal;

      this.onloadData(this.gridDataSourceBid)
    })
  }

  onloadData(obj) {
    let data = obj.map(x => {
      let dateStr = x.BIDREQUESTDATE ? this.pipeDate.transform(x.BIDREQUESTDATE, 'yyyy-MM-dd') : '';
      let date;
      if (dateStr) {
        date = new Date(dateStr);
        date.setDate(date.getDate() + 1);
      }

      let item = {
        id: x.ProjectID,
        text: x.ProjectNumber,
        startDate: date,
        endDate: date,
        test: x.BIDREQUESTDATE
      }

      return item;
    })
  }

  goEditProject(item) {

    if (item.issaleslead == 0) {
      this.router.navigateByUrl(`/salesProject/editSales/${item.ProjectID}`);
    } else {
      this.router.navigateByUrl('/salesLeads/editLead/' + item.ProjectID);
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }

  substrultimatechar(element) {
    return element.substr(0, element.length - 2);
  }


  // ++++++++++++++++++++++++++++++++++++


  //  Sites

  getServiceSite() {
    this.MapInformationService.SaveInfoSites({ method: "Get_ServiceSitesbyCustomer", custooomerid: this.customerID })
      .subscribe(resp => {
        let datos = resp.map(x => {
          // x.ACTIVE = x.ACTIVE == 'Yes' ? true : false;
          // x.HASCONTRACT = x.HASCONTRACT == 'Yes' ? true : false;
          // x.HASASSEt = x.HASASSEt == 'Yes' ? true : false;
          return x;
        });
        this.DataSourceSites = datos
      })
  }


  goEditSite(item) {
    // this.router.navigateByUrl('/editServiceSites');
    this.router.navigate(['/serviceSites/editServiceSite'], { queryParams: { numSITEID: item.ID } })
  }


  onToolbarPreparingSite(e, buttonName) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: buttonName
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
  }

  updateCheck(item, data, e) {

    let active
    let hasContract
    let hasAssest

    switch (item) {
      case "Active":
        active = !data.ACTIVE;
        active = active == true ? 1 : 0;
        hasContract = data.HASCONTRACT == true ? 1 : 0;
        // hasAssest = data.HASASSEt == true ? 1 : 0;
        break;
      case "HasContract":
        hasContract = !data.HASCONTRACT;
        hasContract = hasContract == true ? 1 : 0;
        active = data.ACTIVE == true ? 1 : 0;
        // hasAssest = data.HASASSEt == true ? 1 : 0;
        break;
      // case "HasAssest":
      //   hasAssest = !data.HASASSEt;
      //   hasAssest = hasAssest == true ? 1 : 0;
      //   active = data.ACTIVE == true ? 1 : 0;
      //   hasContract = data.HASCONTRACT == true ? 1 : 0;
      //   break;
    }
    let info = {
      method: "Insert_ServiceSiteCE",
      id: data.ID,
      hascontract: hasContract,
      active: active,
      // hasasset: hasAssest
    };
    this.MapInformationService.SaveInfoSites(info).subscribe(result => {
      this.toast.success(this.translate.instant('msgInfUpdSucc'));
      this.getServiceSite();
    })
  }

  // ++++++++++++++++++++++++++++++++++

  getActivity() {
    const data = {
      method: "Get_Customer_Activities",
      customerid: this.customerID
      // customerid: "1164"
    }
    this.MapInformationService.SaveInfoSites(data)
      // this.customerService.GetCustomerActivityEmployeesFilter({})
      .subscribe(resp => {
        console.log(resp)
        let infoFinal = []
        this.PopupNewActivity = false
        resp.forEach(element => {
          let duration = ""
          if (element.DURATION != undefined) {
            duration = element.DURATION.toString().split(".")
            if (duration[1] == undefined) {
              if (duration[0].length == 2) {
                duration = duration[0] + ":" + "00"
              } else {
                duration = "0" + duration[0] + ":" + "00"
              }
            } else {
              if (duration[0].length == 2) {
                if (duration[1].length == 2) {
                  duration = duration[0] + ":" + duration[1]
                } else {
                  duration = duration[0] + ":" + duration[1] + "0"
                }
              } else {
                if (duration[1].length == 2) {
                  duration = "0" + duration[0] + ":" + duration[1]
                } else {
                  duration = "0" + duration[0] + ":" + duration[1] + "0"
                }
              }
            }
          }
          element.DURATION = duration
          element.CLOSED1 = element.CLOSED == "Yes" || element.CLOSED == true ? true : false

          element.FOLLOWUPCOMMENTSsinHTML = element.FOLLOWUPCOMMENTS != undefined ? this.eliminarHTML(element.FOLLOWUPCOMMENTS) : ""

          infoFinal.push(element)
        })

        this.Activity = infoFinal


        this.customerService.GetCustomerActivityEmployees().subscribe(
          data => {
            this.optionsPeople = data.map((val) => {
              return { // Return the new object structure
                label: val.value,
                value: val.ID
              };
            });
          })
        this.customerService.GetCustomerActivityType().subscribe(
          data => {
            this.optionsCType = data.map((val) => {
              return { // Return the new object structure
                label: val.Name,
                value: val.ID
              };
            });
          },
          err => {
          }
        );
      })
  }

  eliminarHTML(cadena) {
    return cadena.replace(/<[^>]+>/g, '');
  }

  getInfoActivity() {
    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
      },
      err => {
      }
    );
  }

  getAssociatePeople(deleted, action?) {
    if (deleted == 0 && action == null) {
      this.checkBoxShowActive = true;
      deleted = 0;
      // this.checkBoxShowInactive = false;
    } else if (action == null) {
      this.checkBoxShowActive = false;
      deleted = 1;
      // this.checkBoxShowInactive = true;
    }

    const info = {
      method: "Get_Customer_Contacts",
      customerid: this.customerID,
      deleted: deleted
      // customerid: "1164"
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.AssociatePeopple = resp.filter((valor, indice) => {
          return valor.CONTACTID != undefined;
        }
        );
        this.customerService.GetCustomerBuyerType().subscribe(result => {
          this.optionsType = result.map((val) => {
            return { // Return the new object structure
              label: val.DESCRIPTION,
              value: val.ID
            };
          });
          this.customerService.GetCustomerOportunityInfluence().subscribe(result => {
            this.optionsInfluence = result.map((val) => {
              return { // Return the new object structure
                label: val.DESCRIPTION,
                value: val.ID
              };
            });
            // this.customerService.GetContactsPeople().subscribe(result => {
            //   if (this.optionsPeopleAsc.length == 0) {
            //     this.optionsPeopleAsc = result.map((val) => {
            //       return { // Return the new object structure
            //         label: val.First + ' ' + val.Last,
            //         value: val.ID
            //       };
            //     });
            //   }
            // });
            let mythis = this
            // this.contactDataSource = new CustomStore({
            //   key: "ID",
            //   useDefaultSearch: false,
            //   load: function (loadOptions: any) {
            //     if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
            //       loadOptions.searchValue = " "
            //     } else {
            //       loadOptions.searchValue = loadOptions.searchValue
            //     }
            //     return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
            //       .toPromise()
            //       .then((data: any) => {
            //         return data;
            //       })
            //       .catch(error => { throw 'Data Loading Error' });
            //   }
            // });
          });
        });
      })
  }

  SaveNewActivity() {
    let formValue;
    formValue = this._formEntityActivity.value;
    // if(!this._formEntityActivity.valid){
    if (formValue.durationDetail.length == 0) {
      this.toast.warning(this.translate.instant('msgAddDuration'))
      return;
    }
    if (formValue.Name.length == 0) {
      this.toast.warning(this.translate.instant('msgAddActName'))
      return;
    }

    // }

    // if(formValue.durationDetail.length == 0){
    //   this.toast.warning(this.translate.instant('msgAddDuration'));
    //   return;
    // }
    // if(formValue.Name.length == 0){
    //   this.toast.warning(this.translate.instant('msgAddActName'));
    //   return
    // }

    formValue.OptCustomer = 1;
    formValue.OptServiceSite = 0;
    formValue.OptProject = 0;

    // formValue.CustomerId = parseInt(this.customerID);
    formValue.Customer = parseInt(this.customerID);

    // Change Format date 2020-07-16 to 20200715 11:11 (Concat hour)
    let TMPdate;
    let HourToedit;

    HourToedit = formValue.Hour;
    formValue.StartTime = new Date(formValue.StartTime);
    formValue.FOLLOWUPDATE = new Date(formValue.FOLLOWUPDATE);

    formValue.Hour = formValue.durationDetail.substr(0, 2);
    formValue.Minute = formValue.durationDetail.substr(2, 5);

    if (parseInt(formValue.Minute) > 60) {
      this.toast.warning("The minutes cannot be greater than 60")
      return false
    }

    if (formValue.Follow == true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Close
    if (formValue.Closed == true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }

    formValue.Employee = formValue.EmployeeId
    formValue.ActivityType = formValue.Type

    if (this.gotoEdit) {

      if (formValue.Follow == true) {
        formValue.Follow = parseInt('1');
      } else { formValue.Follow = parseInt('0'); }
      // Closed
      if (formValue.Closed == true) {
        formValue.Closed = parseInt('1');
      } else { formValue.Closed = parseInt('0'); }
      // END hange boolean ton strin 0 and 1
      if (formValue.Name === "") {
        formValue.Name = "New Activity";
      }

      const infoFinal = {
        Hour: formValue.Hour,
        Minute: formValue.Minute,
        ActivityType: formValue.Type,
        Closed: formValue.Closed,
        Customer: parseInt(this.customerID),
        Employee: formValue.EmployeeId,
        FollowUp: formValue.Follow,
        Name: formValue.Name,
        Description: formValue.Notes == undefined ? "" : formValue.Notes,
        OptCustomer: 1,
        OptProject: 0,
        OptServiceSite: 0,
        Project: 0,
        ServiceSite: 0,
        StartTime: formValue.StartTime,
        activityid: formValue.Id,
        method: "UpdateActivity",
        followupdate: formValue.FOLLOWUPDATE,
        FollowUpComments: formValue.FollowComments == undefined ? "" : formValue.FollowComments,
      }
      formValue = infoFinal
    } else {
      formValue.Description = formValue.Notes
      formValue.FollowUpComments = formValue.FollowComments
      formValue.followupdate = formValue.FOLLOWUPDATE
      formValue.method = "SaveActivity"
    }

    // this.MapInformationService.getParameters("UpdateActivity")
    // .subscribe(resp=>{
    // })
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      data => {
        this.toast.success(this.translate.instant('msgAcCreSucc'));
        this.CloseNewActivity()
        this.getActivity()
        this.gotoEdit = false
        this.nombreActivity = "New Activity"
      })

  }


  editActivity(data) {
    let formValue;
    formValue = this._formEntityActivity.value;
    formValue.Follow = data.data.FOLLOWUP
    formValue.Closed = data.data.CLOSED1

    if (formValue.Follow === true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Closed
    if (formValue.Closed === true) {
      formValue.Closed = parseInt('1');
    } else { formValue.Closed = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }

    let hour = data.data.DURATION.substr(0, 2);
    let minute = data.data.DURATION.substr(2, 5);
    if (hour.length == 1) {
      hour = "0" + hour
    }
    if (minute.length == 1) {
      minute = minute + "0"
    }

    if (parseInt(minute) > 60) {
      this.toast.warning("The minutes cannot be greater than 60")
      this.getActivity()
      return false
    }
    formValue.Hour = hour
    formValue.Minute = minute

    const infoFinal = {
      Hour: formValue.Hour,
      Minute: formValue.Minute,
      ActivityType: data.data.TYPE,
      Closed: formValue.Closed,
      Customer: this.customerID,
      Employee: data.data.EMPLOYEEID,
      FollowUp: formValue.Follow,
      Name: data.data.NAME,
      Notes: data.data.NOTES == undefined ? "" : data.data.NOTES,
      OptCustomer: 1,
      OptProject: 0,
      OptServiceSite: 0,
      Project: 0,
      ServiceSite: 0,
      StartTime: data.data.DATE,
      activityid: data.data.ID,
      method: "UpdateActivity",
      FollowUpComments: data.data.FOLLOWUPCOMMENTS == undefined ? "" : data.data.FOLLOWUPCOMMENTS,
    }
    this.MapInformationService.SaveInfoSites(infoFinal).subscribe(
      // this.customerService.PostInsertUpdateCustomerActivity(infoFinal).subscribe(
      data => {
        this.toast.success(this.translate.instant('msgActEdiSucc'));
        this.getActivity()
      },
      err => {
      }
    )
  }

  SaveNewAssociatePeople() {
    this._formEntityAssociatePeople.value.method = "Insert_MultipleCustomer_To_Contacts"
    this._formEntityAssociatePeople.value.customerid = this.customerID
    this.MapInformationService.SaveInfoSites(this._formEntityAssociatePeople.value).subscribe(
      // this.customerService.PostInsertCustomerContacts(this._formEntityAssociatePeople.value).subscribe(
      data => {
        // if (data[0].Result) {
        this.toast.success(this.translate.instant('msgAssPeopCreSucc'));
        this.CloseNewAssociatePeopple();
        this.getAssociatePeople(0)
        this.contactDataSource = []
        this.newRequestBySelect.placeholder = "Select.."
        // } else {
        //   this.toast.error('Error Creating Associate People');
        // }
      },
      err => {
      }
    )
    this.contactDataSource = []
  }

  InicioEditPeople(event) {
    let mythis = this
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  editAssociatePeopple(data) {
    const info = {
      id: data.data.ID,
      customerid: this.customerID,
      // CustomerId: "1164",
      description: data.data.DESCRIPTION,
      buyertypeId: data.data.BUYERTYPEID == undefined ? 0 : data.data.BUYERTYPEID,
      infuenceid: data.data.INFLUENCEID,
      contactid: data.data.CONTACTID,
      method: "Insert_MultipleCustomer_To_Contacts"
    }

    this.customerService.EditInsertCustomerContacts(info).subscribe(
      data => {
        if (data[0].Result) {
          this.toast.success(this.translate.instant('msgEditAssPeopSucc'));
          this.getAssociatePeople(0, true)
        } else {
          this.toast.error('Error Edited Associate People');
        }
      },
      err => {
      }
    )
    this.contactDataSource = []
  }

  DeleteADocument(event) {
    let info = {
      method: "Delete_Customer_Contacts",
      customerid: this.customerID,
      contactid: event.key.CONTACTID,
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success("Registry deleted successfully")
        this.getAssociatePeople(0, true)
      })
  }

  handleAddressChange(event) {
    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumber = test.long_name;
        }
        if (test.types[0] == "route") {
          this.street = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCity = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapState = test.short_name;
          // this.mapState = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountry = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCode = test.long_name;
        }
        let streets = this.street && this.houseNumber ? (this.houseNumber + ', ' + this.street) : '';
        test = streets ? streets : this.street;
      }
    }
    this._formEntityEdit.get('address').setValue(event.formatted_address)
    this._formEntityEdit.get('city').setValue(this.mapCity)
    this._formEntityEdit.get('zip').setValue(this.mapPaostalCode)
    this._formEntityEdit.get('country').setValue(this.mapcountry)
    this._formEntityEdit.get('state').setValue(this.mapState)
  }

  handleAddressChangeBilling(event) {
    for (let i = 1; i < event.address_components.length; i++) {
      let test = event.address_components[i];
      if (test.long_name != '') {
        if (test.types[0] == "street_number") {
          this.houseNumberBilling = test.long_name;
        }
        if (test.types[0] == "route") {
          this.streetBilling = test.long_name;
        }
        if (test.types[0] == "locality") {
          this.mapCityBilling = test.long_name;
        }
        if (test.types[0] == "administrative_area_level_1") {
          this.mapStateBilling = test.short_name;
          // this.mapStateBilling = test.long_name;
        }
        if (test.types[0] == "country") {
          this.mapcountryBilling = test.long_name;
        }
        if (test.types[0] == "postal_code") {
          this.mapPaostalCodeBilling = test.long_name;
        }
        let streets = this.streetBilling && this.houseNumberBilling ? (this.houseNumberBilling + ', ' + this.streetBilling) : '';
        test = streets ? streets : this.streetBilling;
      }
    }
    this._formEntityEdit.get('billingaddress').setValue(event.formatted_address)
    this._formEntityEdit.get('billingcity').setValue(this.mapCityBilling)
    this._formEntityEdit.get('billingzip').setValue(this.mapPaostalCodeBilling)
    this._formEntityEdit.get('billingcountry').setValue(this.mapcountryBilling)
    this._formEntityEdit.get('billingstate').setValue(this.mapStateBilling)

  }

  getInitials(str) {
    return this.generalService.getInitials(str);
  }

  clearFilter() {
    this.customerFilter = {
      PageIndex: 1,
      PageSize: 20,
      OrderID: 1,
      Id: 0,
      CustomerName: '',
      CustomerNumber: '',
      SalesPerson: '',
      CustomerType: '',
      SalesRegion: '',
      City: '',
      State: '',
      Zip: '',
      OfficePhone: '',
      HasCredit: '',
      Active: '',
      OffFax: ''
    };

    this.modelSalesPerson = '';
    this.modelCustomerType = '';
    this.customers = [];
    this.lastSearchZero = false;
    this.GetCustomersWithFilters(true);

  }

  goEdit(data) {
  }

  GetCustomersWithFilters(isFilter = false) {
    // if (!this.customerFilter.Id) {
    //   this.customerFilter.Id = 0;
    // }
    if (this.loading == true) { return 0; }
    this.loading = true;
    if (isFilter) {
      this.customerFilter.PageIndex = 1;
      this.lastSearchZero = false;
      this.customerFilter.SalesPerson = this.modelSalesPerson ? this.modelSalesPerson.join(',') : '';
      this.customerFilter.CustomerType = this.modelCustomerType ? this.modelCustomerType.join(',') : '';
    }
    localStorage.setItem('customerFilter', JSON.stringify(this.customerFilter));

    this.setGrid2();
    // this.customerService.GetCustomerFilters(this.customerFilter).subscribe(result => {
    //   this.customerFilter.PageIndex++;
    //   this.loading = false;

    //   if (result.length > 0) {
    //     if (isFilter) {
    //       this.customers = result;
    //     } else {

    //       const tempCopy = JSON.parse(JSON.stringify(this.customers));

    //       result.forEach(element => {
    //         tempCopy.push(element);
    //       });

    //       this.customers = tempCopy;
    //       // result.forEach(element => {
    //       //   this.customers.push(element);
    //       // });
    //     }
    //   } else {
    //     this.lastSearchZero = true;
    //   }

    //   if (isFilter && result.length == 0) {
    //     this.customers = [];
    //   }

    //   localStorage.setItem('customerData', JSON.stringify(this.customers));
    // });
  }

  GetSalesPerson() {
    this.generalService.GetSalesPerson().subscribe(result => {
      this.salesPersonSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME,
          value: val.ID
        };
      });
    });
  }

  GetCustomerType() {
    this.customerService.GetCustomerType().subscribe(result => {
      this.customerTypeSelect = result.map((val) => {
        return { // Return the new object structure
          label: val.CUSTOMERTYPE,
          value: val.ID
        };
      });

    });
  }

  GetCountries() {
    this.customerService.GetCountries().subscribe(result => {
      this.contrySelect = result.map((val) => {
        return { // Return the new object structure
          label: val.COUNTYNAME,
          value: val.CountryISO3
        };
      });
    });
  }



  customScroll() {
    var mythis = this;

    $('#myScrollCustomer').on('scroll', function () {
      if (($(this).scrollTop() + $(this).innerHeight() + 100) >= $(this)[0].scrollHeight && mythis.cargandoScroll == 0) {
        if (mythis.lastSearchZero == false) {
          mythis.GetCustomersWithFilters();
          mythis.page = mythis.page + 1
          mythis.cargandoScroll = 1
          mythis.GetinfoScroll()
        }
      }
    });
  }


  GetinfoScroll() {
    const info = {
      method: "Get_Customers_Pagination",
      pageindex: this.page,
      pagesize: 30
    }
    this.loading = true;

    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        resp.sort(function (a, b) {
          var nameA = a.CUSTOMERNAME.toUpperCase();
          var nameB = b.CUSTOMERNAME.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        resp.forEach(element => {
          this.dataCardList.push(element)
        });

        this.loading = false;
        this.cargandoScroll = 0

      })
  }
  /****************************
   * *** Modal New Custumer ***
   */
  submitFormNewCustumer(goToedit?: boolean) {
    let formValue = this._formEntity.value;
    if (formValue.Billing === false || formValue.Billing === null) {
      // delete formValue.BillingAddress
      formValue = { CustomerAddressSame: 'false', ...formValue };
    } else {
      //  Error: El servicio no esta guardandolos campos a continuacion
      formValue.BillingAddress = formValue.Address;
      formValue.BillingCity = formValue.City;
      formValue.BillingZip = formValue.Zip;
      formValue.BillingState = formValue.State;
      formValue.BillingCountry = formValue.Country;
      // Se implementa el siguiente campo CustomerAddressSame
      formValue = { CustomerAddressSame: 'true', ...formValue };
    }
    delete formValue.Billing;
    // save
    this.customerService.PostNewCustumer(formValue).subscribe(
      data => {
        // this._formEntity.reset();
        this.toast.success(this.translate.instant('msgCustCreSucc'));
        if (goToedit) {
          this.router.navigate(['/customers/editCustomer/' + data[0].Column1]);
        }
      },
      err => {
      }
    );
  }
  saveAndNew() {
    this.submitFormNewCustumer(false);
    this.clearForm();
  }
  saveAndEdit() {
    this.submitFormNewCustumer(true);
  }
  clearForm() {
    this._formEntity = this.fb.group({
      CustomerName: [null, [Validators.required, Validators.maxLength(45)]],
      CustomerNumber: [null, []],
      CustomerTpeId: [{ value: 12, disabled: false }, []],
      OffPhone: [null, [Validators.maxLength(20)]],
      OffFax: [null, [Validators.maxLength(20)]],
      WebSite: [null, []],
      Address: [null, []],
      City: [null, []],
      Zip: [null, []],
      EmployeeId: [{ value: 1, disabled: false }, []],
      State: [null, []],
      Country: [{ value: 'USA', disabled: false }, []],
      Billing: [null, []],
      Notes: [null, []],
      BillingName: [null, [Validators.maxLength(50)]],
      BillingAddress: [null, []],
      BillingCity: [null, []],
      BillingZip: [null, []],
      BillingState: [null, []],
      BillingCountry: [{ value: 'USA', disabled: false }, []],
    });
  }
  deleteCustumer() {
    this.customerService.deleteCustumer(this.customerSelecte).subscribe(
      data => {
        this.GetCustomersWithFilters();
        this.toast.success(this.translate.instant('msgCompDelSucc'));
        this.customerSelecte = null;
        this.namedeleteContacSelect = null;
      },
      err => {
        this.customerSelecte = null;
        this.namedeleteContacSelect = null;

      }
    )
  }

  ModifyHasCredit(event, data) {
    const info = {
      method: "Update_CustomerActiveHastCredit",
      active: data.data.AVAILABLE == true ? 1 : 0,
      hascredit: event.value == true ? 1 : 0,
      customerid: parseInt(data.data.CUSTOMERID)
    }
    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('msgHasCreUpdSucc'))
      })
  }

  ModifyActive(event, data) {
    const info = {
      method: "Update_CustomerActiveHastCredit",
      active: event.value == true ? 1 : 0,
      hascredit: data.data.HASCREDIT == true ? 1 : 0,
      customerid: parseInt(data.data.CUSTOMERID)
    }

    this.MapInformationService.SaveInfoSites(info)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('msgAvaUpdSucc'))
      })
  }

  goLink() {
    let enlace = this._formEntityEdit.get('website').value.trim();
    console.log("enlace?? ", enlace);

    if (enlace != '' && enlace != null) {
      if (!enlace.startsWith("http://") && !enlace.startsWith('https://')) {
        enlace = 'http://' + enlace;
      }
      console.log("ENLACE ", enlace);
      window.open(enlace, '_blank');
    }
  }

  navigateToSWO(item) {
    if (item.selectedItem != undefined) {
      this.NameContact = item.selectedItem.label
      this._formEntityAssociatePeople.get("contactid").setValue(item.selectedItem.ID)
    }
  }


  OpenNewContact() {
    this.popupNewContact = true
  }

  setNewActivityType(event) {
    this._formEntityActivity.get("Type").setValue(event[0].ReturnID)
  }

  get_durations_grid(data) {
    let item = data
    if (item.includes(':')) {
      let hour = data.split(':')[0];
      let minute = data.split(':')[1];
      if (!minute) {
        minute = "00"
      }
      return hour + ':' + minute;
    } else {
      return item + ":" + "00";
    }
  }



  InicioEdit(event) {
    let duration
    if (event.data.DURATION != undefined) {
      duration = event.data.DURATION.toString().split(":")
      if (duration[1] == undefined) {
        if (duration[0].length == 2) {
          duration = duration[0] + "00"
        } else {
          duration = "0" + duration[0] + "00"
        }
      } else {
        if (duration[0].length == 2) {
          if (duration[1].length == 2) {
            duration = duration[0] + duration[1]
          } else {
            duration = duration[0] + duration[1] + "0"
          }
        } else {
          if (duration[1].length == 2) {
            duration = "0" + duration[0] + duration[1]
          } else {
            duration = "0" + duration[0] + duration[1] + "0"
          }
        }
      }
    }
    this.durationEdit = duration
  }

  dataForm: any;
  setFormActivities(val) {

    this.dataForm = val
    this.PopupNewActivity = true;

    // this.CloseNewActivity()
    // this.getInfoActivity()
    // let durat = val.DURATION ? val.DURATION.toString().split(':') : ['', ''];
    // durat[0] = durat[0].padStart(2, '0');
    // durat[1] = durat[1].padEnd(2, '0');
    // // let minute = val.DURATION ? `0${val.DURATION.toString().split('.')[0]}:${val.DURATION.toString().split('.')[1]}` : '';
    // let minute = durat[0] + ':' + durat[1];
    // this._formEntityActivity = new FormGroup({
    //   Id: new FormControl({ value: val.ID, disabled: false }, []),
    //   OptCustomer: new FormControl({ value: 1, disabled: false }, []),
    //   OptServiceSite: new FormControl({ value: 0, disabled: false }, []),
    //   OptProject: new FormControl({ value: 0, disabled: false }, []),
    //   Hour: new FormControl({ value: new Date(val.DATE), disabled: false }, []),
    //   Minute: new FormControl({ value: minute, disabled: false }, []),
    //   ProjectId: new FormControl({ value: 1, disabled: false }, []),
    //   // CusomerActivityId: new FormControl({ value: null, disabled: false }, []),
    //   EmployeeId: new FormControl({ value: !val.EMPLOYEEID ? 0 : val.EMPLOYEEID, disabled: false }, []),
    //   Type: new FormControl({ value: val.TYPE, disabled: false }, [Validators.required]),
    //   Notes: new FormControl({ value: val.NOTES, disabled: false }, []),
    //   StartTime: new FormControl({ value: val.STARTTIME, disabled: false }, [Validators.required]),
    //   FOLLOWUPDATE: new FormControl({ value: val.FOLLOWUPDATE, disabled: false }, []),
    //   Follow: new FormControl({ value: val.FOLLOWUP == false ? 0 : 1, disabled: false }, []),
    //   Name: new FormControl({ value: val.NAME, disabled: false }, [Validators.required]),
    //   Closed: new FormControl({ value: val.CLOSED1 == false ? 0 : 1, disabled: false }, []),
    //   CustomerId: new FormControl({ value: 0, disabled: false }, []),
    //   ServiceSiteId: new FormControl({ value: 0, disabled: false }, []),
    //   FollowComments: new FormControl({ value: val.FOLLOWUPCOMMENTS, disabled: false }, []),
    //   CustomerName: new FormControl({ value: val.CustomerName, disabled: false }, []),
    //   durationDetail: new FormControl({ value: "", disabled: false }, [Validators.required]),
    // });

    // let duration = ""
    // if (val.DURATION != undefined) {
    //   duration = val.DURATION.toString().split(":")
    //   if (duration[1] == undefined) {
    //     if (duration[0].length == 2) {
    //       duration = duration[0] + "00"
    //     } else {
    //       duration = "0" + duration[0] + "00"
    //     }
    //   } else {
    //     if (duration[0].length == 2) {
    //       if (duration[1].length == 2) {
    //         duration = duration[0] + duration[1]
    //       } else {
    //         duration = duration[0] + duration[1] + "0"
    //       }
    //     } else {
    //       if (duration[1].length == 2) {
    //         duration = "0" + duration[0] + duration[1]
    //       } else {
    //         duration = "0" + duration[0] + duration[1] + "0"
    //       }
    //     }
    //   }
    // }
    // this.PopupNewActivity = true;

    // this._formEntityActivity.get('durationDetail').setValue(duration);
    // this.gotoEdit = true
    // this.nombreActivity = "Edit Activity"
    // this.now = new Date(val.DATE);

  }
  GoToContact(data) {
    this.router.navigate(['/contacts/editContact/' + data.data.CONTACTID]);
  }

  PostAccountingSystem() {
    // this.MapInformationService.SaveInfoSites({method:"",customerID:this.customerID})
    // .subscribe(resp=>{
    //   this.toast.success("Integration made successfully")
    // })
  }

  EnableButton() {
    // this.MapInformationService.SaveInfoSites({method:"",customerID:this.customerID})
    // .subscribe(resp=>{
    //   this.ngOnInit()
    //   this.EnableIntegration = false
    // })
  }

  ChangeClosed(event, data) {
    console.log(event)
    console.log(data)

    const infoFinal = {
      Hour: data.id,
      Minute: data.id,
      ActivityType: data.TYPE,
      Closed: event.value == true ? 1 : 0,
      Customer: this.customerID,
      Employee: data.EMPLOYEEID,
      FollowUp: data.FOLLOWUP == true ? 1 : 0,
      Name: data.NAME,
      Description: data.NOTES,
      OptCustomer: 1,
      OptProject: 0,
      OptServiceSite: 0,
      Project: 0,
      ServiceSite: 0,
      StartTime: data.STARTTIME,
      activityid: data.ID,
      method: "UpdateActivity",
      followupdate: data.FOLLOWUPDATE,
      FollowUpComments: data.FOLLOWUPCOMMENTS,
    }

    this.MapInformationService.SaveInfoSites(infoFinal)
      .subscribe(resp => {
        this.toast.success("Updated Successfully")
        this.getActivity()
      })
  }

  popupDeleteActivity: boolean = false
  idActivity: any
  DeleteServiceActivity(data) {
    console.log(data)
    this.popupDeleteActivity = true
    this.idActivity = data.data.ID
  }


  deleteActivity() {
    this.MapInformationService.SaveInfoSites({ method: "Delete_ActivityListByProject", id: this.idActivity })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegDel'));
        this.popupDeleteActivity = false
        this.getActivity()
      })
  }

  closeActivity(e, data) {
    let newData = data.data;
    newData.CLOSED = e.value == false ? 'No' : 'Yes';

    console.log(data)

    const dataFinal = {
      "id": data.data.ID,
      "activityid": data.data.ID,
      "closed": e.value == false ? 0 : 1,
      "method": "UpdateCloseActivity",
    }

    this.MapInformationService.SaveInfoSites(dataFinal)
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgActTemCreSucc'));
        this.getActivity();
      })
  }

  // ******************************* import template

  infoTemplate: any[] = []
  openImport: boolean = false
  OpenImport() {
    let tampleatesInfo = {
      method: "Get_ActivityTemplate",
    };
    this.infoTemplate = [];
    this.MapInformationService.SaveInfoSites(tampleatesInfo).subscribe(
      (res) => {
        console.log(res)
        this.infoTemplate = res.map(x => {
          x.closedYesOrNot = x.CLOSED == true ? "Yes" : "No"
          return x
        })
        this.openImport = true
      }
    );

  }

  DeselectAll() {
    this.openImport = false
    this.GridTemplate.instance.deselectAll()
  }


  SaveInfo() {
    let data = this.GridTemplate.instance.getSelectedRowsData()
    if (data.length > 0) {
      console.log(data)

      let contador = 0
      data.forEach(e => {

        let Hour = "00";
        let Minute = "00";
        let durationFinal
        if (e.DURATION != undefined) {
          Hour = e.DURATION.toString().substr(0, 2);
          Minute = e.DURATION.toString().substr(2, 5);
        }

        durationFinal = Hour + "." + Minute

        let test = {
          id: 0,
          customerid: this.customerID,
          servicesiteid: null,
          employeeid: e.EMPLOYEEID,
          type: e.TYPE == null || e.TYPE == 0 ? 1 : e.TYPE,
          notes: e.NOTES,
          starttime: e.STARTTIME == null ? "" : e.STARTTIME,
          endtime: e.ENDTIME,
          followup: e.FOLLOWUP == true ? 1 : 0,
          followupdate: new Date(),
          name: e.NAME,
          closed: e.CLOSED == true ? 1 : 0,
          followupcomments: e.FOLLOWUPCOMMENTS,
          // projectid:this.salesLeadsId,
          duration: Number(durationFinal),
          externallink: e.EXTERNALLINK,
          method: "InsertUpdateActivity",
        }

        console.log('Guardando Data ', test)
        // this.MapInformationService.InsertUpdateActivity(test).subscribe(result => {
        this.MapInformationService.SaveInfoSites(test).subscribe(result => {
          contador++
          if (contador == data.length) {
            this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegLoadSucc'));
            this.openImport = false
            this.GridTemplate.instance.deselectAll()
            this.getActivity()
          }
        }, error => {
          console.log(error)
        });
      })
    } else {
      this.toast.warning(this.translate.instant('ModalEditSalesLeads.msgSelReg'));
    }
  }


  dataCreateTemplate: any[] = []
  openNewEditTemplateModal: boolean = false
  OpenNewEditTemplate(reload = undefined) {

    this.MapInformationService.SaveInfoSites({ method: "Get_ActivityTemplate" })
      .subscribe(resp => {
        console.log(resp)
        this.dataCreateTemplate = []
        this.dataCreateTemplate = resp.map(x => {
          x.DURATION = this.formatDuration(x);
          x.closedYesOrNot = x.CLOSED == true ? "Yes" : "No"
          return x
        })
        if (reload == undefined) {
          this.openNewEditTemplateModal = true
          this.getActivityType()
          this.getEmployeesActivity()
        }
      })
  }

  formatDuration(element) {
    let duration = ""
    if (element.DURATION != undefined) {
      duration = element.DURATION.toString()

      let hour = element.DURATION.toString().substr(0, 2);
      let minute = element.DURATION.toString().substr(2, 5);

      if (minute == undefined) {
        console.log(hour.length)
        if (hour.length > 1) {
          duration = hour + ":" + "00"
        } else if (hour.length == 1) {
          duration = "0" + hour + ":" + "00"
        }
      } else {
        if (hour.length == 2) {
          if (minute.length == 2) {
            duration = hour + ":" + minute
          } else if (minute.length == 1) {
            duration = hour + ":" + minute + "0"
          }
        } else {
          if (minute.length == 2) {
            duration = "0" + hour + ":" + minute
          } else {
            duration = "0" + hour + ":" + minute + "0"
          }
        }
      }
    }
    return duration;
  }

  ValueOriginal: any[] = []
  getActivityType() {

    this.customerService.GetCustomerActivityType().subscribe(
      data => {
        this.optionsCType = data.map((val) => {
          return { // Return the new object structure
            label: val.Name,
            value: val.ID
          };
        });
        console.log(this.optionsCType)
        this.ValueOriginal = this.optionsCType
      },
      err => {
        console.log(err)
      }
    );
  }

  getEmployeesActivity() {
    this.customerService.GetCustomerActivityEmployees().subscribe(
      data => {
        this.optionsPeople = data.map((val) => {
          // console.log(val.value)
          return { // Return the new object structure
            label: val.value,
            value: val.ID
          };
        });
        console.log(this.optionsPeople)
      })
  }

  InsertinfoDinamica(event) {

    if (event.key.NAME == undefined) {
      this.toast.warning("You must enter a name");
      return
    }

    if (event.key.DURATION != undefined) {
      if (event.key.DURATION.includes(':')) {
        let hour = event.key.DURATION.toString().substr(0, 2);
        let minute = event.key.DURATION.toString().substr(3, 5);
        hour = hour.replace(' ', 0);
        minute = minute.replace(' ', 0);
        event.key.DURATION = hour + minute
      }
    }


      console.log(event.key)
      let dataFinal = {
        id: 0,
        customerid: this.customerID,
        servicesiteid: event.key.SERVICESITEID == undefined ? 0 : event.key.SERVICESITEID,
        employeeid: event.key.EMPLOYEEID,
        date: event.key.DATE,
        type: event.key.TYPE === undefined ? 1 : event.key.TYPE,
        notes: event.key.NOTES,
        starttime: event.key.STARTTIME,
        endtime: event.key.ENDTIME,
        followup: event.key.FOLLOWUP == true ? 1 : 0,
        // followupdate:event.key.id,
        name: event.key.NAME,
        // duedate:event.key.id,
        // completiondate:event.key.id,
        // completionpercenr:event.key.id,
        closed: event.key.CLOSED == true ? 1 : 0,
        followupcomments: event.key.FOLLOWUPCOMMENTS,
        // intvalue:event.key.id,
        // marketcampid:event.key.id,
        // projectid:this.salesLeadsId,
        duration: event.key.DURATION,
        externallink: event.key.EXTERNALLINK,
        // externallink:event.key.id,
        method: "InsertUpdate_ActivityTemplate"
      }
      console.log(event.key)
      console.log(dataFinal)
      this.MapInformationService.SaveInfoSites(dataFinal)
        .subscribe(resp => {
          this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegUpSucc'));
          this.OpenNewEditTemplate("reload")
        })
    }

    UpdateinfoDinamica(event) {
      console.log(event)

      if (event.key.NAME == undefined) {
        this.toast.warning("You must enter a name");
        return
      }
  
      if (event.key.DURATION != undefined) {
        if (event.key.DURATION.includes(':')) {
          let hour = event.key.DURATION.toString().substr(0, 2);
          let minute = event.key.DURATION.toString().substr(3, 5);
          hour = hour.replace(' ', 0);
          minute = minute.replace(' ', 0);
          event.key.DURATION = hour + minute
        }
      }


      console.log(event.key)
      // console.log(hour)
      // console.log(minute)

      // Helper function to add properties only if they have valid values
      const addIfValid = (obj: any, key: string, value: any) => {
        if (value !== undefined && value !== null) {
          obj[key] = value;
        }
      };

      let dataFinal: any = {
        method: "InsertUpdate_ActivityTemplate"
      };

      // Property mapping: source -> target
      const propertyMapping = {
        'ID': 'id',
        'CUSTOMERID': 'customerid',
        'SERVICESITEID': 'servicesiteid',
        'EMPLOYEEID': 'employeeid',
        'DATE': 'date',
        'TYPE': 'type',
        'NOTES': 'notes',
        'STARTTIME': 'starttime',
        'ENDTIME': 'endtime',
        'NAME': 'name',
        'FOLLOWUPCOMMENTS': 'followupcomments',
        'PROJECTID': 'projectid',
        'DURATION': 'duration',
        'EXTERNALLINK': 'externallink'
      };

      // Add properties dynamically
      Object.entries(propertyMapping).forEach(([sourceKey, targetKey]) => {
        addIfValid(dataFinal, targetKey, event.key[sourceKey]);
      });

      // Always include these boolean properties
      dataFinal.followup = event.key.FOLLOWUP == true ? 1 : 0;
      dataFinal.closed = event.key.CLOSED == true ? 1 : 0;

      
      console.log(event.key)
      console.log(dataFinal)
      this.MapInformationService.SaveInfoSites(dataFinal)
        .subscribe(resp => {
          this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegUpSucc'));
          this.OpenNewEditTemplate("reload")
        })
    }
  private _unsubscribe = new Subject<void>();

  deleteDetail(event) {
    console.log(event)
    this.MapInformationService.SaveInfoSites({ method: "Delete_ActivityTemplateByID", id: event.data.ID })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModalEditSalesLeads.msgRegDel'));
        this.OpenNewEditTemplate("reload")
      })
  }

  CloseModal() {
    this.openNewEditTemplateModal = false
  }

  goToCalendar() {
    this.router.navigateByUrl(`/myActivity`)
  }

  dataFromAI: any = ""

  GenerateByAI() {
    const data = this._formEntityEdit.value

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "CUSTOMER_GET_INFO"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {
      console.log(result);

      result.forEach(item => {
        if (item.TYPEPROMPT && item.TYPEPROMPT.split(':')[0] === 'General_info') {
          const key = item.TYPEPROMPT.split(':')[2]; // Extract the key after the second colon
          const spDinamic = item.TYPEPROMPT.split(':')[1]; // Extract the key after the second colon
          const newVariable = {
            [key]: this.customerID,// Assign the extracted key with the value of this.customerID
            method: spDinamic,
          };

          console.log(newVariable);

          this.MapInformationService.SaveInfoSites(newVariable).subscribe(result => {
            console.log(result);

            const resultString = JSON.stringify(result);

            let prompt = {
              systemPrompt: `${item.USERPROMPT}  ${resultString}`,
              userPrompt: `${item.USERPROMPT}  ${resultString}`,
            };

            this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
              // console.log(result.content)
              this.dataFromAI = result.content
              this.openAIGenerate = true
              this.showAI = true
            })
          })
        } else {
          console.error('Invalid TYPEPROMPT format or not General_info');
        }
      });
    });


  }

  CleanInput(type) {
    if (type == 'Notes') {
      this._formEntityEdit.get('customernotes').setValue('')
    } else if (type == 'BillingNotes') {
      this.customerProfile = ''
    }
  }

  showAI = false
  dataHtml = ''
  ExpandInput(type) {
    this.dataHtml = type
    if (type == 'Notes') {
      this.openAIGenerate = true
      this.showAI = false
      this.dataFromAI = this._formEntityEdit.value.customernotes
    } else if (type == 'Profile') {
      this.openAIGenerate = true
      this.dataFromAI = this.customerProfile
      this.showAI = true
    }
  }

  GenerateByAINew(type) {
    if (type == 'Notes') {
      const dataSPAI = {
        method: "GetCubeOpenAIQuestionByType",
        topic: "CUSTOMER_GET_INFO"
      }
      this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {

        result.forEach(item => {
          if (item.TYPEPROMPT && item.TYPEPROMPT.split(':')[0] === 'Notes_Customer') {
            const key = item.TYPEPROMPT.split(':')[2]; // Extract the key after the second colon
            const spDinamic = item.TYPEPROMPT.split(':')[1]; // Extract the key after the second colon
            const newVariable = {
              [key]: this.customerID,// Assign the extracted key with the value of this.customerID
              method: spDinamic,
            };
            this.MapInformationService.SaveInfoSites(newVariable).subscribe(result => {
              const resultString = JSON.stringify(result);
              let prompt = {
                systemPrompt: `${item.USERPROMPT}  ${resultString}`,
                userPrompt: `${item.USERPROMPT}  ${resultString}`,
              };
              this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
                this._formEntityEdit.get('customernotes').setValue(result.content)
              })
            })
          } else {
            console.error('Invalid TYPEPROMPT format or not General_info');
          }
        });
      });
    } else if (type == 'Profile') {
      const dataSPAI = {
        method: "GetCubeOpenAIQuestionByType",
        topic: "CUSTOMER_GET_INFO"
      }
      this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {

        result.forEach(item => {
          if (item.TYPEPROMPT && item.TYPEPROMPT.split(':')[0] === 'Customer_profile') {
            const key = item.TYPEPROMPT.split(':')[2]; // Extract the key after the second colon
            const spDinamic = item.TYPEPROMPT.split(':')[1]; // Extract the key after the second colon
            const newVariable = {
              [key]: this.customerID,// Assign the extracted key with the value of this.customerID
              method: spDinamic,
            };
            this.MapInformationService.SaveInfoSites(newVariable).subscribe(result => {
              const resultString = JSON.stringify(result);
              let prompt = {
                systemPrompt: `${item.USERPROMPT}  ${resultString}`,
                userPrompt: `${item.USERPROMPT}  ${resultString}`,
              };
              this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
                this.customerProfile = result.content
              })
            })
          } else {
            console.error('Invalid TYPEPROMPT format or not General_info');
          }
        });
      });
    }
  }

  chatInput: string = ''
  SendMessageAI() {
    console.log("aqui message")
    console.log(this.chatInput)

    let prompt = {
      systemPrompt: `Using this information ${this.dataFromAI}  ${this.chatInput}`,
      userPrompt: `Using this information ${this.dataFromAI}  ${this.chatInput}`,
    };
    this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
      this.dataFromAI = result.content
      this.chatInput = ''
    })
  }

  toggleOptionsMenu(): void {
    this.showOptions = !this.showOptions;
  }

  handleMenuClick(event: any): void {
    const selectedOption = event.itemData.id;
    if (selectedOption === 'sendEmail') {
      // this.sendEmail();
    } else if (selectedOption === 'updateInfo') {
      // this.updateInformation();
    }
    this.showOptions = false; // Close the menu after selection
  }

  showOptions = false;

  menuOptions = [
    { id: 'sendEmail', text: 'Send Email' },
    { id: 'updateInfo', text: 'Update Information' },
  ];




  // New chatbot

  @ViewChild("messagesContainer", { static: false }) messagesContainer: ElementRef;
  userInput: string = '';
  skipIntroduction = false;

  appUser: string;

  isRecording: boolean = false;

  savingUserSetting = false;
  message: any;
  isNavCollapse = false;
  typeSupport = [];
  currentUrl = '';
  isButtonDisabled: boolean = true;

  onSkipIntroductionChanged(event: any) {
  }


  buttonData = [
    { title: 'HELP AND SUPPORT', action: 'USER_HELP' },
    { title: 'VIRTUAL ASSISTANT', action: 'USER_ACTION' },
    { title: 'DATA ANALYST', action: 'DATA_ANALYST' }
  ];

  clickedButtonIndex: number = -1;

  messages: { author: string, text: string, time: string, authorName: string }[] = [
  ];

  messagescopy: { author: string, text: string, time: string, authorName: string }[] = [
  ];

  onButtonClick(title: string, action: string, index: number) {
    this.clickedButtonIndex = index;
    var messagesupport = '';
    if (index == 0) {
      messagesupport = 'How can I assist you? For example, you could ask, "How do I create an estimate?"';
    } else if (index == 1) {
      messagesupport = 'How can I assist you? For example, you could ask, "Create an estimate with this project name."';
    } else if (index == 2) {
      messagesupport = 'How can I assist you? For example, you could ask, "Analyze monthly sales."';
    } else {
      messagesupport = 'How can I assist you? For example, you could ask about anything related to control engineering, "Is there a Visio Add-In for Control Engineering?"';
    }
    this.messages.push({
      author: 'Virtual Assistant',
      text: messagesupport,
      time: 'Just now',
      authorName: 'Virtual Assistant'
    });
  }

  sendMessage() {
    if (this.userInput.trim()) {
      this.messages.push({
        author: 'User',
        text: this.userInput,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });
      this.respondToMessage('');
      this.userInput = '';
    }
  }

  toggleRecording() {
    if (this.isRecording == false) {
      this.service.start();
      this.isRecording = true;
    }
    else {
      this.service.stop();
      this.isRecording = false;
      this.userInput = this.service.text;
      this.messages.push({
        author: 'User',
        text: this.userInput,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });
      this.respondToMessage('');
      this.userInput = '';
    }
  }

  respondToMessage(msg: string) {


    var soloMsg = '';

    var themessages = JSON.stringify(this.messages);

    if (msg != '') {

      this.messagescopy = [];

      this.messagescopy.push({
        author: localStorage.getItem('userName'),
        text: msg,
        time: 'Just now',
        authorName: localStorage.getItem('userName')
      });

      themessages = JSON.stringify(this.messagescopy);

      soloMsg = msg;

    }
    else {
      if (this.messages.length != 0) {
        soloMsg = this.messages[this.messages.length - 1].text
      }
    }

    // if (msg != ''){ themessages = msg  }

    const currentURL = document.location.origin + document.location.pathname;
    const encodedURL = encodeURIComponent(currentURL);


    this.userService.getcubechatResponse({ base64: "", textPrompt: themessages, usToken: localStorage.getItem('token'), currentURL: encodedURL, solotextPrompt: soloMsg, usercurrenttopic: this.buttonData[this.clickedButtonIndex].action }).subscribe(result => {
      this.textToVoiceService.speak(result);
      this.isButtonDisabled = false;
      this.messages.push({
        author: 'Virtual Assistant',
        text: result,
        time: 'Just now',
        authorName: 'Virtual Assistant'
      });
      localStorage.setItem('botmessages', JSON.stringify(this.messages));
      // this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight; 
      // alert('Hola'); 
    });
  }

  stopVoice() {
    this.isButtonDisabled = true;
    this.textToVoiceService.stop();
  }


  getContactsCustomer() {
    let mythis = this;
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName", loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }


  partestimaterequestbyname: any = "";

  updateContactId(item) {

    if (item.selectedItem.ID) {
      this._formEntityEdit.get('maincontactid').setValue(item.selectedItem.ID);
      //console.log(item.selectedItem)
      // this.state = item.selectedItem.First + ' ' + item.selectedItem.Last;
      this.partestimaterequestbyname = item.selectedItem.ContaNameID;
      //console.log(this.partestimaterequestbyname)
    }
  }


  openUtilityReu: boolean = false;

  idField: string;
  nameField: string;
  serviceToSave: string;
  serviceToDelete: string;
  serviceGet: string;
  idFieldSaveOrModify: string;
  nameFieldSaveOrModify: string;

  goUtilityRegion() {
    console.log("Utility")
    this.openUtilityReu = true

    this.idField = "ID"
    this.nameField = "SALESREGION"
    this.serviceGet = "Customer/GetCustomerSalesRegion"

    this.serviceToSave = "Update_Insert_CustomerDivision"
    this.idFieldSaveOrModify = "id"
    this.nameFieldSaveOrModify = "DivisionName"
  }

  itemsCommandsActions = [
    { id: 1, name: 'Add Sales Lead' },
    { id: 2, name: 'Add Project' }
  ]

  popupSalesLead: boolean = false
  popupCreateSalesProject: boolean = false

  cancel() {
    this.popupCreateSalesProject = false
  }


  onItemsClickCommands(e) {
    switch (e.itemData.id) {
      case 1:
        this.initSalesLead()
        this.popupSalesLead = true
        break;
      case 2:
        this.popupCreateSalesProject = true
        break;
    }
  }

  _formNewSales: FormGroup;




  clearFormNewSales() {
    this._formNewSales = new FormGroup({
      Name: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
      Salesemp: new FormControl({ value: 1, disabled: false }, []),
      biddate: new FormControl({ value: "", disabled: false }, []),
    });
  }


  submitNewLeads(edit, newitem = false) {

    let formValue;
    formValue = this._formNewSales.value;
    formValue = { bidstatus: 1, ...formValue };

    formValue.method = "Insert_webLeads"
    formValue.name = formValue.Name
    formValue.salesemp = formValue.Salesemp
    formValue.id = 0
    formValue.biddate = new Date(formValue.biddate)

    delete formValue.Name
    delete formValue.Salesemp
    this.MapInformationService.SaveInfoSites(formValue).subscribe(
      // this.salesLeadsService.newSalesLeads(formValue).subscribe(
      data => {
        if (data[0].ReturnID) {
          this.toast.success(this.translate.instant('msgLeadCreSucc'));
          this.popupSalesLead = false
          this.clearFormNewSales();
        } else {
          this.toast.error('Error Creating Sales Lead');
        }
      },
      err => {
        this.toast.error('Error Creating Sales Lead');
      }
    )

  }

  initSalesLead() {
    this._formNewSales = new FormGroup({
      Name: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
      Salesemp: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      biddate: new FormControl({ value: "", disabled: false }, []),
    });
  }

  isSalesPerson: boolean = false;
  defaultSalesPerson: any;


  getSalesPerson() {
    this.salesLeadsService.GetSalesPerson().pipe(takeUntil(this._unsubscribe)).subscribe(
      (data: any) => {
        console.log("🚀 ~ getSalesPerson ~ data:", data)

        this.optionsSalesPerson = data.map((val) => {

          if (this.isSalesPerson && val.ID == localStorage.getItem('customerid')) {
            this.defaultSalesPerson = val.ID;
          }

          return { // Return the new object structure
            label: val.CONTACTNAME,
            value: val.ID
          };
        });
      },
      err => {
        console.log(err);
      }
    )
  }

  onsavecontact(ev) {
    console.log(ev)
    let obj = {
      selectedItem: {
        ID: ev.id,
        First: ev.First,
        Last: ev.Last
      }
    };

    this._formEntityEdit.get('maincontactid').setValue(ev.id);
    this.partestimaterequestbyname = ev.id
    this.newRequestBySelectSelectDetail.placeholder = ev.First + " " + ev.Last + " (" + ev.Email + ")"

    // this.newRequestBySelect

    let mythis = this
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = "je"
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.contactService.GetContactByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    // this.updateContactId(obj);
  }

  resultNewEmployee(item) {
    this.popupNewEmployee = false;
    this.searchInfoToSelect();
  }

  goToEmployee() {
    this.router.navigateByUrl(`employees/editEmployees?strEMPNUMBER=${this._formEntityEdit.get("employeeid").value}&strID=${this._formEntityEdit.get("employeeid").value}`);
  }


  addToSalesPerson() {
    let employeesToAdd = this.employeesNoSalesSelect.filter(x => x.add == true);

    employeesToAdd.forEach(element => {
      this.salesLeadsService.UpdateEmployeeToSales(element.ID).subscribe(result => {
        this.getSalesPerson();
        this.getEmployeesNoSales();
      });

    });

    this.toast.success(this.translate.instant('msgSalPerSuccUdp'));
    this.popupSalesPerson = false;
  }


  dataManufactured = []
  Get_VendorsAll() {
    let info = {
      method: 'Get_VendorsMasterCompactList'
    }

    this.MapInformationService.MethodCallApiFlex(info).subscribe(resp => {
      this.dataManufactured = resp
      console.log("🚀 ~ NewPartComponent ~ this.MapInformationService.MethodCallApiFlex ~ this.dataManufactured:", this.dataManufactured)
    })
  }



}

